module.exports = __webpack_public_path__ + "img/arrow_white_down.4153bbc.png";